module.exports = __webpack_public_path__ + "img/home_page_four_side_bg.ab8801b2.png";